var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTableHeight } from "@/hooks/useTableHeight";
import { Table } from "antd";
import React, { useCallback, useRef, useState } from "react";
var InfinityTable = function (_a) {
    var columns = _a.columns, dataSource = _a.dataSource, loading = _a.loading, hasMore = _a.hasMore, containerStyle = _a.containerStyle, onLoadMore = _a.onLoadMore, props = __rest(_a, ["columns", "dataSource", "loading", "hasMore", "containerStyle", "onLoadMore"]);
    var _b = useState(dataSource), localData = _b[0], setLocalData = _b[1];
    var contentRef = useRef(null);
    var tableHeight = useTableHeight(contentRef);
    var loadMoreData = useCallback(function () {
        if (loading || !hasMore)
            return;
        onLoadMore === null || onLoadMore === void 0 ? void 0 : onLoadMore();
    }, [loading, hasMore, onLoadMore]);
    var handleScroll = function (event) {
        var _a = event.currentTarget, scrollTop = _a.scrollTop, clientHeight = _a.clientHeight, scrollHeight = _a.scrollHeight;
        if (scrollHeight - scrollTop === clientHeight && !loading && hasMore && onLoadMore) {
            loadMoreData();
        }
    };
    React.useEffect(function () {
        setLocalData(dataSource);
    }, [dataSource]);
    return (_jsx("div", { ref: contentRef, style: __assign({ height: "70vh" }, containerStyle), onScroll: handleScroll, children: _jsx(Table, __assign({ columns: columns, onScroll: handleScroll, dataSource: localData, scroll: { x: 1200, y: tableHeight }, pagination: false, loading: loading }, props)) }));
};
export default InfinityTable;
